export const ACTIVITY_TYPES = {
  QUIZ: 'Quiz',
  PHOTO: 'Photo/Video',
  CHALLENGE: 'Physical challenge',
  FINISH_LINE: 'Finish line',
  VOUCHER: 'Voucher/coupon',
  ADVERTISEMENT: 'Advertisement',
  UNLOCK_ONLY: 'Unlock only',
  MANAGEMENT_TIP: 'Management tip',
}

export function disabledActivities(type) {
  // limit types of activities for the moment
  return type !== ACTIVITY_TYPES.PHOTO && type !== ACTIVITY_TYPES.QUIZ && type !== ACTIVITY_TYPES.UNLOCK_ONLY
}

export default {
  disabledActivities,
  ACTIVITY_TYPES
}
